module.exports = __webpack_public_path__ + "static/img/widget-6.783b3af8.png";